import './Polyfills/Polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './Fonts.css';
import App from './App';
import { TranslateProvider } from 'translate-components';
import translations from './Translations/translations.json';
import { unregister } from './registerServiceWorker';




ReactDOM.render(
    <TranslateProvider translations={translations} defaultLanguage={"sr"}>
        <App />
    </TranslateProvider>,
    document.getElementById('root')

);


unregister();



// WEBPACK FOOTER //
// ./src/index.js